<template>
	<div>
		<CoolLightBox :index="index" :items="getLightBoxImages" @close="index = null"></CoolLightBox>
		<meta-info-file
			ref="metaInfoFile"
			:chooseable="chooseable"
			:deletable="deletable"
			:editable="editable"
			:chooseable-default="chooseableDefault"
			:is-edit-mode="isEditMode"
			:meta-info-media="metaInfoMedia"
			@edit="isEditMode = !isEditMode"
			v-on="$listeners"
		>
			<img
				:src="metaInfoMedia.base64Content"
				alt="Foto"
				class="w-full bg-cover bg-center flex flex-grow relative text-right cursor-pointer"
				@click="index = 0"
			/>
		</meta-info-file>
		<div v-if="isEditMode" class="space-y-4 mt-4">
			<BaseCheckbox v-if="!hideShowCustomer" v-model="metaInfoMedia.show_customer" :label="$t('visible_for_customer')" />
			<BaseInput v-model="metaInfoMedia.note" :label="$t('comment_input')">
				<textarea v-model="metaInfoMedia.note" class="resize-y w-full shadow-m h-32" maxlength="160"></textarea>
			</BaseInput>
			<div class="flex justify-end">
				<SaveButton @click="save" />
			</div>
		</div>
	</div>
</template>

<script>
import MetaInfoFile from '@/components/damagecases/forms/MetaInfoFile';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox';
import BaseInput from '@/components/forms/inputs/BaseInput';
import SaveButton from '@/components/forms/buttons/SaveButton';
import { DamagecasesApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';

export default {
	name: 'MetaInfoImage',
	components: { SaveButton, BaseInput, BaseCheckbox, MetaInfoFile },
	props: {
		metaInfoMedia: {
			required: true,
		},
		chooseable: {
			type: Boolean,
		},
		chooseableDefault: {
			default: false,
		},
		deletable: {
			type: Boolean,
			default: true,
		},
		editable: {
			type: Boolean,
			default: false,
		},
		hideShowCustomer: {
			default: false,
		},
	},
	data() {
		return {
			index: null,
			isEditMode: false,
		};
	},
	methods: {
		save() {
			DamagecasesApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.damagecasesIdWorkingimagesImageIdPut(
					this.$route.params.processId || this.$route.params.id,
					this.metaInfoMedia.working_image_id,
					this.metaInfoMedia,
				)
				.then(response => {
					this.$swal(this.$t('general.success').toString(), this.$t('working_photo_saved').toString(), 'success');
					this.isEditMode = false;
				})
				.catch(error => {
					this.$swal(this.$t('general.error').toString(), this.$t('working_photo_save_error').toString(), 'error');
				});
		},
		toggleCheckMetaInfoImage(status) {
			this.$refs.metaInfoFile.toggleCheckbox(status);
		},
	},
	computed: {
		getLightBoxImages() {
			return [this.metaInfoMedia]
				.map(metaInfo => {
					if (metaInfo.base64Content) {
						return metaInfo.base64Content;
					}
				})
				.filter(value => value);
		},
	},
};
</script>

<style scoped></style>
